<div class="ofwca-details-view-container" *ngIf="ofwcaObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info" *ngIf="ofwcaObject?.assetsRegional?.uuid !== 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="ofwcaObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="id-info-v2" *ngIf="ofwcaObject?.assetsRegional?.uuid === 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="ofwcaObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="competition-requirements-met-status-info" *ngIf="ofwcaObject?.assetsRegional?.uuid !== 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
    <mat-form-field *ngIf="ofwcaObject.competitionRequirementsMet" appearance="fill" [ngClass]="'input-color-positive'">
      <mat-label>Status IDD konkursy</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="'Aktywny'">
    </mat-form-field>
    <mat-form-field *ngIf="!ofwcaObject.competitionRequirementsMet" appearance="fill" [ngClass]="'input-color-negative'">
      <mat-label>Status IDD konkursy</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="'Nieaktywny'">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + ofwcaObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="ofwcaObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).ofwca.write || generatingDocument" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
<!--    <button [disabled]="!(userPermissions | async).ofwca.delete" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>-->
    <button mat-stroked-button [matMenuTriggerFor]="menu" aria-label="Menu" color="primary">
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #menu="matMenu" class="ofwcadropdown">
      <button
        [disabled]="!(userPermissions | async).ofwca.regional_change"
        (click)="changePartner()"
        mat-menu-item
      ><mat-icon>edit</mat-icon> <span> Przepięcie OFWCA</span></button>
      <button
        [disabled]="!(userPermissions | async).ofwca.regional_change"
        (click)="changeRegional()"
        mat-menu-item
      ><mat-icon>edit</mat-icon> <span> Zmiana regionalnego</span></button>
      <button
        [disabled]="!(userPermissions | async).ofwca.read || generatingDocument"
        [class.spinner]="generatingDocument" (click)="generateDocuments()"
        mat-menu-item
      ><mat-icon>content_copy</mat-icon> <span> Wygeneruj oświadczenia</span></button>
<!--      <button-->
<!--        [disabled]="!(userPermissions | async).contract.write || generatingDocument"-->
<!--        [class.spinner]="generatingDocument" (click)="generateAuthorizations(false)"-->
<!--        mat-menu-item-->
<!--      ><mat-icon>content_copy</mat-icon> <span> Wygeneruj wszystkie upoważnienia</span></button>-->
      <button
        [disabled]="!(userPermissions | async).contract.write || generatingDocument"
        [class.spinner]="generatingDocument" (click)="generateAuthorizations(true)"
        mat-menu-item
      ><mat-icon>content_copy</mat-icon> <span> Wygeneruj nowe upoważnienia</span></button>
      <button
        [disabled]="!(userPermissions | async).ofwca.delete || generatingDocument"
        [class.spinner]="generatingDocument" (click)="generateContractWithEmployee(false)"
        mat-menu-item
      ><mat-icon>content_copy</mat-icon> <span> Wygeneruj wszystkie umowy z pracownikiem</span></button>
      <button
        [disabled]="!(userPermissions | async).ofwca.delete || generatingDocument"
        [class.spinner]="generatingDocument" (click)="generateContractWithEmployee(true)"
        mat-menu-item
      ><mat-icon>content_copy</mat-icon> <span> Wygeneruj nowe umowy z pracownikiem</span></button>
      <a mat-menu-item href="/rest/crm/static/doc/Klauzula_informacyjna_GRUPA_ASF.pdf" target="_blank">
        <mat-icon>attach_file</mat-icon> <span> Klauzula informacyjna</span>
      </a>
      <button
        [disabled]="!(userPermissions | async).ofwca.regional_change"
        (click)="accountNumber()"
        mat-menu-item
      ><mat-icon>edit</mat-icon> <span> Zmiana nr rachunku bankowego</span></button>
      <button
        [disabled]="!(userPermissions | async).registration.id_import"
        (click)="hiperiodata()"
        mat-menu-item
      ><mat-icon>edit</mat-icon> <span>  Edycja danych Hiperio</span></button>
      <button *ngIf="!ofwcaObject.blockedRegistration" [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).block_ofwca.delete"  (click)="blockOfwca()"   mat-menu-item >
        <mat-icon>lock</mat-icon>Zablokuj OFWCA</button>

      <button *ngIf="ofwcaObject.blockedRegistration" [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).block_ofwca.delete"  (click)="unlockOfwca()"   mat-menu-item >
        <mat-icon>lock_open</mat-icon>Odblokuj OFWCA</button>

      <button  mat-menu-item  [disabled]="true"> <span> </span></button>
      <button *ngIf="ofwcaObject.hiperioAgencyUnitsUuid && hiperioAgencyUnitObject  && hiperioAgencyUnitObject?.activationStatus!=='INACTIVE'" [class.spinner]="generatingDocument"  (click)="updateHiperioOfwca('INACTIVE')"   mat-menu-item >
        <mat-icon>lock</mat-icon>Zablokuj konto Hiperio</button>

      <button *ngIf="ofwcaObject.hiperioAgencyUnitsUuid && hiperioAgencyUnitObject  && hiperioAgencyUnitObject?.activationStatus!=='ACTIVE'" [class.spinner]="generatingDocument"   (click)="updateHiperioOfwca('ACTIVE')"   mat-menu-item >
        <mat-icon>lock_open</mat-icon>Odblokuj konto hiperio</button>

      <button *ngIf="ofwcaObject.hiperioAgencyUnitsUuid && hiperioAgencyUnitObject  && hiperioAgencyUnitObject?.activationStatus!=='SUSPENDED'" [class.spinner]="generatingDocument"   (click)="updateHiperioOfwca('SUSPENDED')"   mat-menu-item >
        <mat-icon>lock</mat-icon>Zawieś konto hiperio</button>

      <button  mat-menu-item  [disabled]="true"> <span> </span></button>
      <button [disabled]="!(userPermissions | async).ofwca.delete" (click)="delete()" mat-menu-item color="warn"
      ><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    </mat-menu>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane osobowe</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię" [value]="ofwcaObject.firstName"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Drugie imię" [value]="ofwcaObject.secondName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Nazwisko" [value]="ofwcaObject.lastName"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="PESEL" [value]="ofwcaObject.pesel" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Nazwisko rodowe" [value]="ofwcaObject.familyName" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Nazwisko panieńskie matki" [value]="ofwcaObject.mothersMaidenName" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię matki" [value]="ofwcaObject.mothersName" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Imię ojca" [value]="ofwcaObject.fathersName" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Miejsce urodzenia" [value]="ofwcaObject.birthPlace" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Data urodzenia" [value]="ofwcaObject.birthDate | date:'y-MM-dd'" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Płeć" [value]="ofwcaObject.sex?.name"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Wykształcenie" [value]="ofwcaObject.education?.name" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Obywatelstwo" [value]="ofwcaObject.citizenship"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Data uzyskania pierwszego wpisu w KNF" [value]="ofwcaObject.firstKnfEntry | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer RAU">
                  <mat-chip-list>
                    <ng-container *ngFor="let rauNumber of ofwcaObject.rauNumbers;">
                      <mat-chip color="accent" selected>{{rauNumber.rau}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>

            </div>
            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100">
                <app-detail header="Numer rachunku bankowego" [value]="ofwcaObject.accountNumber"></app-detail>
              </div>

             </div>

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="100">-->
<!--                <app-detail-bool header="Rekord zweryfikowany" [value]="ofwcaObject.verified"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool header="Podpisana umowa z pracownikiem" [value]="ofwcaObject.signedContractWithTheEmployee"></app-detail-bool>
              </div>
              <div fxFlex="100">
                <app-detail-bool header="Zablokowana OFWCA" [value]="ofwcaObject.blockedRegistration"></app-detail-bool>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row"fxFlex.lt-md="100" *ngIf='(userPermissions | async).settlement.delete'>
        <div fxFlex="100" >
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Blokady rozliczeń ASF</h3>
            </div>

            <div  fxLayout="row"  fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Blokada wysyłki rozliczenia ASF"  [value]="ofwcaObject.settlementSendBlockAsf"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool header="Blokada wysyłki rozliczenia Premium" [value]="ofwcaObject.settlementSendBlockPremium"></app-detail-bool>
              </div>
            </div>
            <div  fxLayout="row"  fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Blokada dodawania rachunku ASF" [value]="ofwcaObject.billAddBlockAsf"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool header="Blokada dodawania rachunku Premium" [value]="ofwcaObject.billAddBlockPremium" ></app-detail-bool>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="(userPermissions | async).ofwca.delete">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Autoryzacja</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--            <app-detail fxFlex="50" header="Kod"  *ngIf="(userPermissions | async).ofwca.admin_root" [value]="ofwcaObject.settlementPassword " ></app-detail>-->
<!--              <app-detail fxFlex="50" header="Kod"  *ngIf="(userPermissions | async).ofwca.delete && !(userPermissions | async).ofwca.admin_root" [value]="null "  [limitedAccess]="true"></app-detail>-->


<!--            <div fxFlex="50" style="align-content: center;  text-align: center;" >-->
<!--              <button-->
<!--                (click)="sendPassword(ofwcaObject.uuid)"-->
<!--                mat-raised-button color="primary" class="send-password"-->
<!--              ><mat-icon>send</mat-icon> <span>Wyślij kod </span></button>-->
<!--            </div>-->

<!--        </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool header="KRK wyrabiane przez OFWCA" [value]="ofwcaObject.krkRequestedByOfwca"></app-detail-bool>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dokument tożsamości</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Typ" [value]="ofwcaObject.documentType?.name" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Organ wydający" [value]="ofwcaObject.documentIssuer" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Numer" [value]="ofwcaObject.documentNumber" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data wydania" [value]="ofwcaObject.documentIssueDate | date:'dd/MM/YYYY'" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Data ważności" [value]="ofwcaObject.documentExpirationDate | date:'dd/MM/YYYY'" [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Kontakt email</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <h5 class="small-margin-header">
                  Adres email główny </h5>
                <ng-container *ngFor="let email of ofwcaObject.emails | mainContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Adres" [value]="email.address"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="email.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="50" header="Konkursowe" [value]="email.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="50" header="Produktowe" [value]="email.product"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="(ofwcaObject.emails | additionalContact).length > 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">Adres email dodatkowy</h5>
                <ng-container *ngFor="let email of ofwcaObject.emails | additionalContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Adres" [value]="email.address"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="email.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="50" header="Konkursowe" [value]="email.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="50" header="Produktowe" [value]="email.product"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>



          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Kontakt telefoniczny</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <h5 class="small-margin-header">Numer telefonu główny  </h5>
                <ng-container *ngFor="let phone of ofwcaObject.phones | mainContractPhone; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Numer" [value]="phone.number | phone"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="phone.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="50" header="Konkursowe" [value]="phone.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="50" header="Produktowe" [value]="phone.product"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px"  *ngIf="(ofwcaObject.phones |  additionalContractPhone).length > 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">Numer telefonu dodatkowy  </h5>
                <ng-container *ngFor="let phone of ofwcaObject.phones | additionalContractPhone; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Numer" [value]="phone.number | phone"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="phone.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="50" header="Konkursowe" [value]="phone.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="5" header="Produktowe" [value]="phone.product"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>


          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="ofwcaObject?.user360?.length > 0">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let user of ofwcaObject?.user360; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
                    <span fxFlex="5">{{ i + 1 }}.</span>

                    <app-detail fxFlex="65" header="Login">{{ user.username }}</app-detail>

                    <app-detail-bool fxLayoutAlign="space-around center" fxFlex="20" header="Aktywny"
                                     [value]="user.active"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row">
              <h3>Zgody</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Aktualności produktowe " [value]="ofwcaObject.productMessageConsent"></app-detail-bool>
              </div>

              <div fxFlex="50">
                <app-detail-bool header="Aktualności marketingowe" [value]="ofwcaObject.contestMessageConsent"></app-detail-bool>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <ng-container *ngIf="!ofwcaObject.withoutAddress">
        <app-detail-address fxFlex.lt-md="100%" header="Adres zameldowania" [address]="ofwcaObject.registeredAddress"></app-detail-address>
        <app-detail-address fxFlex.lt-md="100%" header="Adres zamieszkania" [address]="ofwcaObject.livingAddress"></app-detail-address>
        <app-detail-address fxFlex.lt-md="100%" header="Adres korespondencyjny" [address]="ofwcaObject.communicationAddress"></app-detail-address>
      </ng-container>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Regionalny (majątek) OFWCA" [value]="ofwcaObject.assetsRegional?.fullName"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Regionalny (życie)" [value]="ofwcaObject.lifeRegional?.fullName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Partner" [value]="ofwcaObject.partner?.shortName"
                            [link]="ofwcaObject.partner ? ['/partnerzy/szczegoly', ofwcaObject.partner.uuid] : undefined"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Właściciel" [value]="ofwcaObject.companyOwner?.shortName"
                            [link]="ofwcaObject.companyOwner ? ['/partnerzy/szczegoly', ofwcaObject.companyOwner.uuid] : undefined"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool header="Właściciel firmy" [value]="ofwcaObject.partner?.ofwcaOwnerUuid === ofwcaObject.uuid"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Placówka" [value]="ofwcaObject.facility?.address?.searchString"
                            [link]="ofwcaObject.facility ? ['/placowki/szczegoly', ofwcaObject.facility?.address?.uuid] : undefined"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer Profitowi" [value]="ofwcaObject.profitNumber"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" >-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Chronie.pl</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <app-detail header="Login" [value]="ofwcaObject.chronieLogin"></app-detail>-->
<!--              </div>-->

<!--              <div fxFlex="50">-->
<!--                <app-detail header="Kod zniżkowy" [value]="ofwcaObject.chronieDiscountCode"></app-detail>-->
<!--              </div>-->
<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Hiperio</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaObject.assetsRegional?.uuid!='d095058c-cf4e-4928-be5a-ae55af272d4b'">
              <div fxFlex="100">
                <app-detail-bool header="Nadanie dostępu" [value]="ofwcaObject.hiperioGrantingAccess"></app-detail-bool>
              </div>
            </div>

<!--            <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaObject.assetsRegional?.uuid!='d095058c-cf4e-4928-be5a-ae55af272d4b'">-->
<!--              <div fxFlex="100">-->
<!--                <app-detail-bool header="Automatyczna aktualizacja dostępów" [value]="ofwcaObject.hiperioAutomaticAccessUpdate"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->

            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="100">
                <app-detail header="Status konta" [value]="hiperioAgencyUnitObject?.activationStatus?  hiperioAgencyUnitObject?.activationStatus === 'ACTIVE' ? 'Aktywne' : 'Zablokowane'  : '-'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Login" [value]="ofwcaObject.hiperioLogin"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Email" [value]="ofwcaObject.hiperioEmail"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="(userPermissions | async).idd_training.read && iddTrainings?.length > 0">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Szkolenia IDD</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field style="width: 100%">
                <mat-label>Szkolenie IDD</mat-label>
                <mat-select [formControl]="iddTrainingControl" [required]="true">
                  <mat-option *ngFor="let iddTraining of iddTrainings" [value]="iddTraining">
                    IDD {{iddTraining.year}} {{iddTraining.ofwca.fullName}} ({{iddTraining.status.name}})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Postęp">
                <app-idd-training-chart
                  class="ofwca-idd-training-card"
                  [routerLink]="['/szkolenia-idd/szczegoly', iddTrainingControl.value.uuid]"
                  [iddTraining]="iddTrainingControl.value"
                  [chartType]="chartType"
                  style="height: 40px;
                  width: 100%;
                  display: block"
                ></app-idd-training-chart>
              </app-detail>
            </div>

            <ng-container *ngIf="iddTrainingControl.value.statement">
              <div fxLayout="row">
                <app-detail
                  fxFlex="100" header="Oświadczenie"
                  [value]="iddTrainingControl.value.statement?.documentName"
                  [link]="['/dokumenty/szczegoly', iddTrainingControl.value.statement?.uuid]"
                ></app-detail>
              </div>

              <div fxLayout="row">
                <app-detail
                  fxFlex="100" header="Data wpisu do rejestru pośredników ubezpieczeniowych"
                  [value]="iddTrainingControl.value.dateOfEntryInRau | date:'y-MM-dd'"
                ></app-detail>
              </div>

              <div fxLayout="row" [style.margin-top]="'15px'">
                <button
                  [disabled]="!(userPermissions | async).document.read"
                  mat-stroked-button (click)="downloadStatement(iddTrainingControl.value.statement)"
                  color="accent"
                >
                  <mat-icon>download</mat-icon> <span> Pobierz oświadczenie</span>
                </button>
              </div>
            </ng-container>

          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" >-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Zgody</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="100">-->
<!--                <app-detail-bool header="Wiadomości produktowe" [value]="ofwcaObject.productMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="100">-->
<!--                <app-detail-bool header="Wiadomości konkursowe" [value]="ofwcaObject.contestMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->
<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="ofwcaObject.maternityLeaveFrom || ofwcaObject.maternityLeaveTo" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Urlop Macierzyński</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data od" [value]="ofwcaObject.maternityLeaveFrom | date:'y-MM-dd'" ></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data do" [value]="ofwcaObject.maternityLeaveTo | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>



      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="" [value]="ofwcaObject.note"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
